import { Box, Grid, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useF25PricingContext } from 'modules/onboarding/components/Pricing/F25PricingContext'

import PricingFaq from 'modules/billing/components/PricingFaq'
import BundleSelector from './_BundleSelector'
import ContactSales from './_ContactSales'
import IncludedFeatures from './_IncludedFeatures'
import ModulesList from './_ModulesList'
import Summary from './_Summary'

const Error = () => {
  const emitEventHandler = () => {
    track(trackingEvents.onboarding.requestToContact, {
      page_url: window.location.href,
      request_type: 'Contact Sales',
      from: 'Pricing plans error'
    })
  }

  return (
    <Box
      gap="s24"
      padding="s24"
      width="fit-content"
      alignSelf="center"
      borderRadius={{ all: 'abs008' }}
      border={{ all: { color: 'grey400', width: 's2', style: 'solid' } }}
    >
      <Text size="400" color="grey1000" weight="medium">
        {i18n.t('pricing_plans.pricing_error')}
      </Text>
      <ContactSales
        ctaLabel={i18n.t('pricing_plans.contact_sales')}
        emitEventHandler={emitEventHandler}
      />
    </Box>
  )
}

const FactorialF25Bundles = () => {
  const { allPlans } = useF25PricingContext()
  const [open, toggle] = useToggle(false)

  return (
    <Box width="full" alignSelf="center" style={{ maxWidth: '1120px' }} gap="s24">
      {!allPlans.f25Plans.length ? (
        <Error />
      ) : (
        <>
          <Box flexDirection="row" gap="s6">
            <Text size="400" color="grey1000" weight="semibold">
              {i18n.t('pricing_plans.recommended_section')}
            </Text>
            <Box alignSelf="center">
              <Tooltip.Alt
                size="small"
                attachment="bottom center"
                open={open}
                toggle={toggle}
                label={i18n.t('pricing_plans.recommended_tooltip')}
              >
                <Icon.Medium icon="info-circle-line" color="grey800" />
              </Tooltip.Alt>
            </Box>
          </Box>
          <Grid variant="fixed">
            <Box gridColSpan={{ xxs: 12, s: 8 }} gap="s24">
              <BundleSelector />
              <IncludedFeatures />
              <Text size="400" color="grey1000" weight="semibold">
                {i18n.t('pricing_plans.modules_section')}
              </Text>
              <ModulesList />
            </Box>
            <Box gridColSpan={{ xxs: 12, s: 4 }}>
              <Summary />
            </Box>
          </Grid>
          <Box gap="s48" paddingTop="s96">
            <PricingFaq />
          </Box>
        </>
      )}
    </Box>
  )
}

export default FactorialF25Bundles
